import request from '../../../core/wrappers/axios-wrapper';
import { RoleApprovalQuery } from '../../../types/constants/apiUrls/roleApproval/roleApprovalQuery';
import { RequestType } from '../../../types/enums/request-enums';

const GetRoleApproversByRoleId = (roleId: number): Promise<any> =>
    request({
        url: `${RoleApprovalQuery.GetRoleApproversByRoleId}/${roleId}`,
        method: RequestType.GET,
    });

const GetUserRoleApprovalRequests = (params: any): Promise<any> =>
    request({
        url: RoleApprovalQuery.GetUserRoleApprovalRequests,
        method: RequestType.GET,
        params: params,
    });

const GetPendingRoleRequestsByApprover = (params: any): Promise<any> =>
    request({
        url: RoleApprovalQuery.GetPendingRoleRequestsByApprover,
        method: RequestType.GET,
        params: params,
    });

const GetRequestableRoles = (): Promise<any> =>
    request({
        url: RoleApprovalQuery.GetRequestableRoles,
        method: RequestType.GET,
    });

const GetStaffInfo = (userRef: number): Promise<any> =>
    request({
        url: `${RoleApprovalQuery.GetStaffInfo}/${userRef}`,
        method: RequestType.GET,
    });

const GetMyActiveRequests = (): Promise<any> =>
    request({
        url: RoleApprovalQuery.GetMyActiveRequests,
        method: RequestType.GET,
    });

const GetMyPastRequests = (params: any): Promise<any> =>
    request({
        url: RoleApprovalQuery.GetMyPastRequests,
        method: RequestType.GET,
        params: params,
    });

const RoleApprovalQueryService = {
    GetRoleApproversByRoleId,
    GetUserRoleApprovalRequests,
    GetPendingRoleRequestsByApprover,
    GetRequestableRoles,
    GetStaffInfo,
    GetMyActiveRequests,
    GetMyPastRequests,
};

export default RoleApprovalQueryService;
